<div class="center" *ngIf="!equipmentPhotosLoaded">
  <mat-spinner></mat-spinner>
</div>
<div class="photos" *ngIf="equipmentPhotosLoaded" [@fadeIn]>
  <div class="photo" *ngFor="let photo of equipmentPhotos">
    <equipment-photo [photo]="photo" [inspectionId]="inspectionId"></equipment-photo>
  </div>
</div>
